"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../container"));
var global_1 = require("../selectors/global");
var global_2 = require("../stores/global");
var setOfflineMode_1 = require("./setOfflineMode");
var fetchPoint_1 = __importDefault(require("./point/fetchPoint"));
var startDownloadNextRequiredMediafile_1 = __importDefault(require("./mediafiles/startDownloadNextRequiredMediafile"));
function setOnlineMode() {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/setOnlineMode");
        var state = getState();
        var isConnected = (0, global_1.selectIsConnected)(state);
        if (isConnected) {
            return;
        }
        logger.info("Going to online mode");
        dispatch((0, global_2.setPlaybackLock)({ offline: false }));
        dispatch((0, global_2.setConnected)(true));
        (0, setOfflineMode_1.removeEmptyPlaylistNotification)(getState(), dispatch);
        dispatch((0, fetchPoint_1.default)());
        dispatch((0, startDownloadNextRequiredMediafile_1.default)());
        dispatch({ type: setOnlineMode.type });
    };
    action.type = setOnlineMode.type;
    return action;
}
setOnlineMode.type = "setOnlineMode";
exports.default = setOnlineMode;
//# sourceMappingURL=setOnlineMode.js.map